import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import { ritzDataContext, selectProjectById } from '@moderepo/mode-data-state-ritz';
import { useRitzTranslation } from '../../utils/customHooks';
import { ProjectDevicesContainer } from '..';
import { ProjectDeviceTableHiddenFields } from './ProjectDevicesContainer';


/**
 * This is the list of device's fields we want to hide from the devices table. This list is static so we can define it outside of the component
 * for optimization
 */
const devicesTableHiddenFields: ProjectDeviceTableHiddenFields = {
    homeId           : true,
    creationTime     : true,
    claimTime        : true,
    availability     : true,
    bundleInstallTime: true,
    channel          : true,
};


/**
 * This page Display ALL the devices' issues or Health status
 */
export const ProjectDevicesPage = () => {
    // Get the params from the route or url
    const params = useParams();
    const projectId = Number(params.projectId);

    const { state:dataState } = useContext(ritzDataContext);
    const project = selectProjectById(dataState, projectId);
    const { trans } = useRitzTranslation(project);


    return (
        <div className="page-main-content">
            <div className="title-bar">
                <div className="title-bar-item title-text">
                    <div className="page-title">
                        {trans('page.title.project_devices')}
                    </div>
                    <div className="page-subtitle">
                        {trans('page.subtitle.project_devices')}
                    </div>
                </div>
            </div>

            {project && (
                <ProjectDevicesContainer
                    projectId={projectId}
                    itemsPerPage={20}
                    hiddenFields={devicesTableHiddenFields}
                />
            )}

            {!project && (
                <CircularProgress />
            )}
        </div>
    );
};
